import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faGithub} from '@fortawesome/free-brands-svg-icons'

const ProjectCard = ({projectDetail}) => {
    const { title , desc, image, technology, location } = projectDetail;
    return (
        <>
            {location === "" ? 
            <div className="project-crd">
                <div className="p-status-container">
                    <div className="p-status">
                        <div className='circleIcon'></div>
                        <p className="p-status-txt">Live</p>
                    </div>
                    <FontAwesomeIcon className='githubIcon' icon={faGithub} size='3x' />
                </div>
                <div className="p-crd-img">
                    <img src={image} alt={title} />
                </div>
                <h5 className="p-crd-title">{title}</h5>
                <p className="p-crd-desc">{desc}</p>
                <h6 className="p-crd-technology">{technology}</h6>
            </div>
            :
            <a href={location} target="_blank">
            <div className="project-crd">
                <div className="p-status-container">
                    <div className="p-status">
                        <div className='circleIcon'></div>
                        <p className="p-status-txt">Live</p>
                    </div>
                    <FontAwesomeIcon className='githubIcon' icon={faGithub} size='3x' />
                </div>
                <div className="p-crd-img">
                    <img src={image} alt={title} />
                </div>
                <h5 className="p-crd-title">{title}</h5>
                <p className="p-crd-desc">{desc}</p>
                <h6 className="p-crd-technology">{technology}</h6>
            </div>
            </a>
          }
            
        </>
    )
}

export default ProjectCard